import { SAVED_CHART_NAME_FIELD, SAVED_FUND_CHART_BOOLEAN_KEYS, SAVED_FUND_CHART_VIEW_STATE_KEYS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FUND } from 'NewAngular/constants/core.constants';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import { SavedChartService } from 'NewAngular/features/components/saved-items/services/common-services/saved-chart.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { sanitizeFundChart } from '../utils/saved-items-utils';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/saved-items/services/common-services/saved-chart.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
export class SavedFundChartService extends BaseSavedItemService {
    constructor(savedChartService, ajaxService, urlsService) {
        super();
        this.savedChartService = savedChartService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.SAVED_FUND_CHART_REQUEST_KEYS = SAVED_FUND_CHART_VIEW_STATE_KEYS.concat([
            'securitylistSecurityId',
            SAVED_CHART_NAME_FIELD,
        ]);
        this.sanitizedFundChart = sanitizeFundChart;
    }
    // Remove when retiring legacy view
    getItems(includeLegacy) {
        return this.savedChartService.getItems(FUND, includeLegacy);
    }
    getFolderableItems(params) {
        return this.ajaxService.getDataObserveBody(this.urlsService.CHARTS.FUND_CHART_COLLECTION, params);
    }
    deleteItem(chartId) {
        return this.savedChartService.deleteItem(chartId, FUND);
    }
    updateItem(chartId, putParams) {
        const flattenedParams = formFlattenedObject(putParams, this.SAVED_FUND_CHART_REQUEST_KEYS);
        // Send all booleans as strings, to align with how they are received in POST requests
        for (let i = 0; i < SAVED_FUND_CHART_BOOLEAN_KEYS.length; i += 1) {
            const key = SAVED_FUND_CHART_BOOLEAN_KEYS[i];
            flattenedParams[key] = flattenedParams[key].toString();
        }
        return this.savedChartService.updateItem(chartId, flattenedParams, FUND);
    }
    createItem(initialPostParams, chartName) {
        const postParams = { ...initialPostParams, [SAVED_CHART_NAME_FIELD]: chartName };
        const flattenedParams = formFlattenedObject(postParams, this.SAVED_FUND_CHART_REQUEST_KEYS);
        return this.savedChartService.createItem(flattenedParams, FUND);
    }
    getErrorMessage(error) {
        return this.savedChartService.getErrorMessage(error);
    }
}
SavedFundChartService.ɵfac = function SavedFundChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedFundChartService)(i0.ɵɵinject(i1.SavedChartService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
SavedFundChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedFundChartService, factory: SavedFundChartService.ɵfac, providedIn: 'root' });
